import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import CityLanding from "@/pages/CityLanding";
import Referral from "@/pages/Referral";
import AuditModal from "@/components/sections/AuditModal";
import { cities } from "@/content/cities";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/referral" element={<Referral />} />
        {/* City landing pages — SEO-friendly URL /jasa-website-{slug} */}
        {cities.map((c) => (
          <Route
            key={c.slug}
            path={`/jasa-website-${c.slug}`}
            element={<CityLanding />}
          />
        ))}
        {/* Catch-all: redirect unknown routes to home (prevents blank page) */}
        <Route path="*" element={<Landing />} />
      </Routes>
      {/* Global modal — accessible from any page via window event 'open-audit-modal' */}
      <AuditModal />
    </BrowserRouter>
  );
}

export default App;
